$(function () {
    $('button.umzugsservice').click(function (e) {
        e.preventDefault();
        openPopUpOverlay('umzugsservice', false);
    });

    $('button.urlaubsservice').click(function (e) {
        e.preventDefault();
        openPopUpOverlay('urlaubsservice', false);
    });

    $('.abo-service-teaserbox-wrapper select').on('change', function() {
        if (this.value) {
            openPopUpOverlay(this.value, false);
        }
    });
});